import { AlertTriangle, MessageCircle, RefreshCw } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isExpiredSubscriber, formatExpirationDate } from "@/utils/authDestination";

const WHATSAPP = "5573981988263";

/**
 * Banner global exibido para usuários cujo plano venceu.
 * Aditivo: não substitui nenhum outro banner do sistema.
 */
const ExpiredPlanBanner = () => {
  const { user, isAuthenticated, profileLoaded } = useAuth();

  if (!isAuthenticated || !profileLoaded) return null;
  if (!isExpiredSubscriber(user)) return null;

  const venceu = formatExpirationDate(user);
  const msg = encodeURIComponent(
    `Olá! Meu plano no IA Palpite Guru venceu${venceu ? ` em ${venceu}` : ""} e quero renovar meu acesso.`
  );

  return (
    <div className="w-full bg-destructive/10 border-b border-destructive/30">
      <div className="container mx-auto px-3 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
        <div className="flex items-start sm:items-center gap-2 flex-1 min-w-0">
          <AlertTriangle className="w-4 h-4 shrink-0 text-destructive mt-0.5 sm:mt-0" />
          <p className="text-xs sm:text-sm text-destructive font-medium leading-snug">
            Seu plano venceu{venceu ? ` em ${venceu}` : ""}. Renove para liberar novamente os
            recursos premium e o Guru Chat.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/pagamento"
            className="inline-flex items-center gap-1.5 rounded-md bg-destructive px-3 py-1.5 text-xs sm:text-sm font-semibold text-destructive-foreground hover:opacity-90 transition-opacity"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Renovar agora
          </Link>
          <a
            href={`https://wa.me/${WHATSAPP}?text=${msg}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-md border border-destructive/40 px-3 py-1.5 text-xs sm:text-sm font-semibold text-destructive hover:bg-destructive/10 transition-colors"
          >
            <MessageCircle className="w-3.5 h-3.5" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default ExpiredPlanBanner;
